import React, { useState, useEffect, useCallback } from "react";
import Layout from "../../layout/Layout";
import { Form } from "react-bootstrap";
import MyEditor from "../../components/MyEditor";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import axiosInstance from "../../utils/axiosConfig";
import * as CustomToast from "../../components/CustomToastMessage";

function EditTip() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: "",
    content: "",
    date: "",
  });
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");

  const fetchTipDetails = useCallback(async () => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/tips/${id}`
      );
      if (response.data.success) {
        const tip = response.data.data;
        setFormData({
          title: tip.title,
          content: tip.content,
          date: tip.date.split("T")[0],
        });
        setSelectedDate(tip.date.split("T")[0]);
      }
    } catch (error) {
      if (error.response.data.status === 400) {
        CustomToast.error(error.response?.data?.message);
      }
      console.error(error.response?.data?.message || "Internal server error");
    }
  }, [id]);
  const location = useLocation();

  useEffect(() => {
    if (id) {
      fetchTipDetails();
    } else if (location.state?.selectedDate) {
      setFormData((prev) => ({
        ...prev,
        date: location.state.selectedDate,
      }));
    }
  }, [id, fetchTipDetails, location]);
  const handleSubmit = async () => {
    try {
      setLoading(true);
      const url = id
        ? `${process.env.REACT_APP_BACKEND_URL}/api/admin/tips/edit/${id}`
        : `${process.env.REACT_APP_BACKEND_URL}/api/admin/tips/create`;

      const method = id ? "put" : "post";

      const response = await axiosInstance({
        method,
        url,
        data: formData,
      });

      if (response.data.success) {
        CustomToast.success(response.data.message);
        if (location.state?.selectedDate) {
          navigate("/calendar");
        } else {
          navigate("/tips");
        }
      }
    } catch (error) {
      if (error.response.data.status === 400) {
        CustomToast.error(error.response?.data?.message);
      }
      console.error(error.response?.data?.message || "Internal server error");
    } finally {
      setLoading(false);
    }
  };

  const handleEditorChange = (content) => {
    setFormData((prev) => ({
      ...prev,
      content: content,
    }));
  };

  return (
    <Layout title={id ? "Edit Tip" : "Add Tip"}>
      <main>
        <div className="card page-card">
          <div className="card-body">
            <div className="row g-3">
              <div className="col-12">
                <Form.Group controlId="title">
                  <Form.Label>Title</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter title"
                    value={formData.title}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        title: e.target.value,
                      }))
                    }
                  />
                </Form.Group>
              </div>
              <div className="col-12">
                <Form.Group controlId="date">
                  <Form.Label>Date</Form.Label>
                  {selectedDate ? (
                    <Form.Control
                      type="date"
                      value={formData.date}
                      // min={new Date().toISOString().split('T')[0]}
                      min={
                        new Date(Date.now() + 86400000)
                          .toISOString()
                          .split("T")[0]
                      }
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          date: e.target.value,
                        }))
                      }
                      onClick={(e) => e.target.showPicker()}
                      pattern="\d{4}-\d{2}-\d{2}"
                      // disabled
                    />
                  ) : (
                    <Form.Control
                      type="date"
                      value={formData.date}
                      min={new Date(Date.now()).toISOString().split("T")[0]}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          date: e.target.value,
                        }))
                      }
                      onClick={(e) => e.target.showPicker()}
                      pattern="\d{4}-\d{2}-\d{2}"
                    />
                  )}
                </Form.Group>
              </div>
              <div className="col-12">
                <Form.Group controlId="content">
                  <Form.Label>Content</Form.Label>
                </Form.Group>
                <MyEditor
                  htmlData={formData.content}
                  setCourseAdd={(content) => {
                    handleEditorChange(content);
                  }}
                />
              </div>
              <div className="col-12 d-flex justify-content-end gap-3">
                <button
                  className="btn-outline fs-16 fw-700 px-4"
                  onClick={() => {
                    if (location.state?.selectedDate) {
                      navigate("/calendar");
                    } else {
                      navigate("/tips");
                    }
                  }}
                  type="button"
                >
                  Cancel
                </button>
                <button
                  className="btn-primary fs-16 fw-700 px-4"
                  onClick={handleSubmit}
                  disabled={loading}
                  type="button"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
}

export default EditTip;
